import { Link } from "react-router-dom"
import { ROOT } from "../../routes/routes_name"
import useFaq from "./useFaq"
import DOMPurify from "dompurify";


const FaqPage = () => {
    const {
        data,
        isLoading,
        numFaq,
        handleSelectFaq,
    } = useFaq()

    return (
        <div id="body" className="index-page">
            <header id="header" className="header d-flex align-items-center fixed-top">
                <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between py-3">
                    <a href={ROOT} className="logo d-flex align-items-center me-auto me-xl-0">
                        <h1 className="sitename"><img src="../assets/img/ppg.png" alt="" srcSet="" /></h1>
                    </a>
                    <Link to={ROOT} className="btn-getstarted"><i className="bi bi-chevron-left"></i> Kembali</Link>
                </div>
            </header>
            <main className="main">
                <div className="page-title light-background">
                    <div className="container">
                        <h1>FAQ</h1>
                        <nav className="breadcrumbs">
                            <ol>
                                <li><a href={ROOT}>Home</a></li>
                                <li className="current">FAQ</li>
                            </ol>
                        </nav>
                    </div>
                </div>
                <section id="service-details" className="service-details faq section">
                    <div className="container">
                        {
                            isLoading ? <p>Loading...</p> :
                                <div className="faq-container">
                                    {
                                        data && data.map((d, i) => (
                                            <div key={i} className={`card faq-item ${i === numFaq ? "faq-active" : ""}`} >
                                                <h3 onClick={() => handleSelectFaq(i)} style={{ fontWeight: "bolder" }}>{d.pertanyaan}</h3>
                                                <div className="faq-content">
                                                    <p dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(d.jawaban) }}></p>
                                                </div>
                                                <i className="faq-toggle bi bi-chevron-right"></i>
                                            </div>
                                        ))
                                    }
                                </div>
                        }
                    </div>
                </section>
            </main>
        </div>
    )
}
export default FaqPage